module.exports = __webpack_public_path__ + "img/horse-racing.29907624.svg";